import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseMessage, DentalReferralForm } from '../app.service';
import { ApiEndpointService } from './api-endpoint.service';

@Injectable({
  providedIn: 'root'
})
export class ReferralLockService {

  constructor(
    private http: HttpClient,
    private apiEndpoint: ApiEndpointService
  ) { }

  // Build the full URL from the server-provided base
  private url(method: string) {
    return this.apiEndpoint.buildUrl(`/api/App/${method}`);
  }

  public LockReferral(request: LockReferralRequest): Observable<LockReferralResponse> {
    return this.http.post<LockReferralResponse>(this.url('LockReferral'), request);
  }

  public UnlockReferral(request: UnlockReferralRequest): Observable<UnlockReferralResponse> {
    return this.http.post<LockReferralResponse>(this.url('UnlockReferral'), request);
  }
}

export class LockReferralRequest {
  referralId: number;
  referralType: string;
}
export class LockReferralResponse extends BaseMessage {
  referral?: DentalReferralForm;
}

export class UnlockReferralRequest {
  referralId: number;
  referralType: string;
}
export class UnlockReferralResponse extends BaseMessage {
  referral?: DentalReferralForm;
}
